module.exports = __webpack_public_path__ + "img/pic_02.089b9b1f.svg";